import _ from 'lodash';
import {useCustomer} from '../../hooks/api/metadata';
import {isIntentFieldDefinition} from '../../shared/fields/intent';
import {getFieldLabel} from '../../shared/fields/types';
import {AccountFieldOrCustomField} from '../../shared/signalDefinition';
import {
  IntentGroup,
  IntentGroups,
  useIntentModelStore,
} from './IntentModeStore';
import {fromEntries} from '../../shared/util';

export type IntentGroupOption = {
  value: AccountFieldOrCustomField;
  label: string;
  isDisabled: boolean;
};

export function useIntentGroupOptions() {
  const customer = useCustomer();
  const fieldDefinitions = customer.fieldDefinitions ?? [];
  const intentSources = customer.intentSources ?? [];
  const {displayFields: fieldsWithWeights} = useIntentModelStore();

  const existingFieldIds = new Set(
    fieldsWithWeights.map((f) => f.id.toString())
  );

  return fromEntries(
    IntentGroups.map((group) => {
      const options = fieldDefinitions
        .filter(isIntentFieldDefinition)
        .filter((fieldDefinition) => {
          if (group === 'linkedIn') {
            return fieldDefinition.source === 'linkedIn';
          }

          if (fieldDefinition.source !== 'aggregated') {
            return false;
          }

          const intentSource = intentSources.find((source) =>
            source.id.equals(fieldDefinition.sourceId)
          );
          return intentSource?.type === group;
        })
        .map((fieldDefinition) => ({
          value: fieldDefinition.id,
          label: getFieldLabel(fieldDefinition),
          isDisabled: existingFieldIds.has(fieldDefinition.id.toString()),
        }));

      return [group, options];
    })
  ) satisfies Record<IntentGroup, IntentGroupOption[]>;
}
